module.exports = __webpack_public_path__ + "img/paint-roller.a7c9abbf.svg";